import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorHasAnInvalidFiscalRegime extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor has an invalid fiscal regimen to enable automatic invoicing', options);
    }
}
export default InvestorHasAnInvalidFiscalRegime;
